/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/utils/alert/index.ts
 * Papel: utilitario congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import { toast, Bounce, ToastPosition, Zoom } from "react-toastify";
import { loadingAlertJSX } from "./loading";

interface LoadingAlertParams {
    msg?: string;
    id?: string;
    autoClose?: number;
    position?: ToastPosition;
}
export function loadingAlert({ msg, id, autoClose, position }: LoadingAlertParams) {

    loadingAlertJSX({ msg, id, autoClose: autoClose ?? 30000000, position })

};

export function successAlert(message: string, autoClose?: number, loadingId?: string | number) {

    if (loadingId) {
        toast.dismiss(loadingId);
    }

    toast.success(message, {
        position: "top-right",
        autoClose: autoClose ?? 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
    });

};

export function errorAlert(message: string, autoClose?: number, loadingId?: string | number, id?: string) {

    if (loadingId) {
        toast.dismiss(loadingId);
    }

    toast.error(message, {
        position: "top-right",
        autoClose: autoClose ?? 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        toastId: id
    });
};

export function infoAlert(message: string, autoClose?: number, loadingId?: string | number) {

    if (loadingId) {
        toast.dismiss(loadingId);
    }

    toast.info(message, {
        position: "top-right",
        autoClose: autoClose ?? 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        toastId: loadingId ?? message
    });
};

export function warningAlert(message: string, autoClose?: number, loadingId?: string | number) {

    if (loadingId) {
        toast.dismiss(loadingId);
    }

    toast.warning(message, {
        position: "top-right",
        autoClose: autoClose ?? 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        toastId: loadingId ?? message
    });
};

export function destroyAlert(toastId?: string) {
    toast.dismiss(toastId);
}